import { computed, observable, makeObservable } from "mobx";
import { Processo, TipoMinuta } from "../modelo";
import { IAutocomplete } from "../modelo/Autocomplete";
import { ComplementoGEDTO, MinutaMovimentos, MovimentoGEDTO } from "../modelo/MinutaMovimentos";

interface OpcaoComplemento {
    id: number;
    checked: boolean;
    descricao: string;
}

class MovimentoCNJStore {
    codigoTipoMinutaSelecionado: TipoMinuta;// = TipoMinuta.DESPACHO;
    processos: Processo[] = [];
    movimentos: MovimentoGEDTO[] = [];
    movimentosMinutas: MinutaMovimentos[] = [];
    movimentoLegadoSelecionado: any;
    movimentoPJeSelecionado: any;

    modalComplementosOpen = false;
    idProcessoModalOpen: number;
    idMovimento: number;
    codMovimentoModalOpen: string;
    complementosPossiveis: ComplementoGEDTO[] = [];
    movimentosExcludentes: any[] = [];
    sameState: boolean = true;
    tiposDecisaoChecked = [true, true, true, true];
    quantidadeMovimentosIncluidos = 0;
    quantidadeMovimentosRemovidos = 0;
    exibeAlertaMovimentoSemCorrespondencia = false;
    complementosAutomaticosSetados = false;
    polosSelecionados: string[] = ['polo ativo'];
    openModalComplementos: boolean = false;
    processoEmProcessamento: Processo;
    movSelecionado = null;
    complementosMovimentoProcessoEmProcessamento = [];
    movimentosMinuta = null;
    minutaSelecionada = null;


    opcoesComplementos: Array<OpcaoComplemento> = [
        { id: 1, descricao: 'Polo ativo', checked: true },
        { id: 2, descricao: 'Polo passivo', checked: false },
        { id: 3, descricao: 'Outros participantes', checked: false }
    ];

    openModalSelecaoPolo = false;
    carregandoComplementosAutomaticos = false;

    constructor() {
        makeObservable(this, {
            codigoTipoMinutaSelecionado: observable,
            processos: observable,
            movimentos: observable,
            movimentosMinutas: observable,
            movimentoLegadoSelecionado: observable,
            movimentoPJeSelecionado: observable,
            modalComplementosOpen: observable,
            idProcessoModalOpen: observable,
            idMovimento: observable,
            codMovimentoModalOpen: observable,
            complementosPossiveis: observable,
            movimentosExcludentes: observable,
            sameState: observable,
            tiposDecisaoChecked: observable,
            quantidadeMovimentosIncluidos: observable,
            quantidadeMovimentosRemovidos: observable,
            exibeAlertaMovimentoSemCorrespondencia: observable,
            complementosAutomaticosSetados: observable,
            polosSelecionados: observable,
            openModalComplementos: observable,
            processoEmProcessamento: observable,
            movSelecionado: observable,
            complementosMovimentoProcessoEmProcessamento: observable,
            movimentosMinuta: observable,
            minutaSelecionada: observable,
            opcoesComplementos: observable,
            openModalSelecaoPolo: observable,
            carregandoComplementosAutomaticos: observable,
            existeProcessoLegado: computed,
            existeProcessoPJe: computed,
            movimentosLegado: computed,
            movimentosPJe: computed,
            movimentosPJeLegado: computed
        });
    }

    get existeProcessoLegado(): boolean {
        return this.processos.some(processo => processo.ehLegado);
    }

    get existeProcessoPJe(): boolean {
        return this.processos.some(processo => processo.ehPje);
    }

    get movimentosLegado(): IAutocomplete<MovimentoGEDTO>[] {
        return this.movimentos?.filter(movimento => movimento.origem === 'L')
            .map(movimento => ({
                valor: movimento,
                texto: movimento.descricaoMovimentoUnificacao + ' - ' + 'Movimento CNJ: ' + movimento.codMovimentoUnificacao + ' / ' + movimento.descricaoMovimento + ' - Decisão ESIJ: ' + movimento.codMovimentoCnj.toString().replace('L-', ''),
                parametrosBusca: [movimento.codMovimentoCnj, movimento.descricaoMovimento, movimento.codMovimentoUnificacao, movimento.descricaoMovimentoUnificacao]
            })).sort((a, b) => {
                return a.valor.descricaoMovimentoUnificacao.trim().localeCompare(b.valor.descricaoMovimentoUnificacao.trim());
            }) || [];
    }

    get movimentosPJe(): IAutocomplete<MovimentoGEDTO>[] {
        return this.movimentos?.filter(movimento => movimento.origem === 'P')
            .map(movimento => ({
                valor: movimento,
                texto: movimento.descricaoMovimento + ' - ' + movimento.codMovimentoCnj.toString().replace('P-', ''),
                parametrosBusca: [movimento.codMovimentoCnj, movimento.descricaoMovimento]
            })).sort((a, b) => {
                return a.valor.descricaoMovimento.trim().localeCompare(b.valor.descricaoMovimento.trim());
            }) || [];
    }
    get movimentosPJeLegado(): IAutocomplete<MovimentoGEDTO>[] {
        const movimentosContatenados = this.movimentosLegado.concat(this.movimentosPJe);
        const movimentosOrdenadosPorDescricao = movimentosContatenados.sort((a, b) => {
            return a.valor.descricaoMovimentoUnificacao.trim().localeCompare(b.valor.descricaoMovimentoUnificacao.trim());
        })
        return movimentosOrdenadosPorDescricao;
    }
}


export default new MovimentoCNJStore();
